import React, { useState, useEffect, useCallback, useRef } from "react";
import CustomButton from "../../../atoms/CustomButton";
import Import from "../../../icons/Import";
import Filter from "../../../icons/Filter";
import CustomDataGrid from "../../../organisms/CustomDatagrid";
import Modal from "../../../organisms/modals/Modal";
import CustomMenu from "../../../atoms/CustomMenu";
import { v4 as uuidv4 } from "uuid";
import Edit from "../../../icons/Edit";
import Delete from "../../../icons/Delete";
import VerticalMenu from "../../../icons/VerticalMenu";
import { getData, deleteData, patchData, postData } from "../../../../services";
import { useCookies } from "react-cookie";
import Form from "./Form";
import moment from "moment/moment";
import Pagination from "../../../molecules/Pagination";
import DeleteModal from "../../../organisms/modals/DeleteModal";
import ConfirmModal from "../../../organisms/modals/ConfirmModal";
import Search from "../../../molecules/search";
import SideOverlay from "../../../atoms/SideOverlay";
import { Select, MenuItem } from "@mui/material";
import {
  getdepartmentList,
  getEmployeeList,
  getRolesList,
  getClientList,
  getAllProjects,
  getTeamsList,
  getBusinessSegmentList,
} from "../../../../services/basicGets";
import toast from "react-hot-toast";
import {
  errorStyles,
  confimationStyles,
} from "../../../../assets/styles/toast";
import StatusBackground from "../../../atoms/StatusBackground";
import ColorDots from "../../../atoms/ColorDots";
import NoContentCard from "../../../atoms/NoContentCard";
import NoContentIcon from "../../../icons/NocontentIcon";
import TaskViewModal from "./tabs/TaskView";
import {
  TaskStatus,
  Priorities,
  TaskType,
} from "../../../../helpers/staticData";
import CommonFilter from "../../../atoms/CommonFilter";
import { Tooltip, Autocomplete, TextField } from "@mui/material";
import TaskCustomDatagrid from "../../../organisms/CustomDatagrid/EditableTable";
import { CheckCheck, CheckCircle, Loader, Tally1, Upload } from "lucide-react";
import CalenderView from "./CalenderView";
import { DateSelector } from "../../../organisms/MonthYearSelector";
import { DatePicker } from "@mui/x-date-pickers";
import { handleClickDownload } from "../../../../services/downloadService";
import { useSelector } from "react-redux";
import LogTime from "./LogTime";
import { useSearchParams } from "react-router-dom";
import { set } from "rsuite/esm/internals/utils/date";
import { TaskStatusOptions } from "../../../../helpers/staticData";
import { formatTime } from "../../../../helpers/timeformathoursminsec";
import { decodeCookieValue } from "../../../../helpers/cookieHelper";

const TaskManagement = ({
  type,
  id,
  information,
  disabled = false,
  mytask,
  home,
  clientdash,
  clientshow,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [cookies] = useCookies([]);
  const [selectedRow, setSelectedRow] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [searchedValue, setSearchedValue] = useState();
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [department, setDepartment] = useState([]);
  const [Projects, setProjects] = useState([]);
  const [roles, setRoles] = useState([]);
  const [Teams, setTeams] = useState([]);
  const [Client, setClient] = useState([]);
  const [BusinessSegment, setBusinessSegment] = useState([]);
  const [Employee, setEmployee] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [removed, setRemoved] = useState([]);
  const [dirtyFlag, setDirtyFlag] = useState(false);
  const [isConfirmCompleteModalOpen, setIsConfirmCompleteModalOpen] =
    useState(false);
  const [confirmModal, setIsConfirmModal] = useState(false);
  const [filteredAssignedTo, setFilteredAssignedTo] = useState(employees);

  const [isUpdate, setIsUpdate] = useState(false);
  const [gridParams, setGridParams] = useState(null);
  const lastFetchedProjectId = useRef(null);

  // Initialize filters from URL params
  const [filters, setFilters] = useState(() => {
    const urlFilters = {};
    if (searchParams.has("status")) {
      urlFilters.status = JSON.parse(searchParams.get("status"));
    }
    if (searchParams.has("priority")) {
      urlFilters.priority = JSON.parse(searchParams.get("priority"));
    }
    if (searchParams.has("assignee")) {
      urlFilters.assignee = JSON.parse(searchParams.get("assignee"));
    }
    if (searchParams.has("delayed")) {
      urlFilters.delayed = JSON.parse(searchParams.get("delayed"));
    }
    if (searchParams.has("client")) {
      urlFilters.client = JSON.parse(searchParams.get("client"));
    }
    return urlFilters;
  });

  const [logTimer, setLogTimer] = useState(false);
  const [logData, setLogData] = useState([]);
  const [modalState, setModalState] = useState({
    isModalOpen: false,
    modalData: null,
    isDeleteModalOpen: false,
    modalId: "",
    name: "",
  });

  const [isExporting, setIsExporting] = useState(false);

  //access details handling
  const accessData = useSelector((state) => state.accessDetails?.accessData);
  const tasksAccess =
    accessData?.access?.find((module) => module.module === "Tasks") || {};
  const isAdmin = accessData?.role?.label === "Admin";

  const canCreate = isAdmin || tasksAccess?.is_create;
  const canEdit = isAdmin || tasksAccess?.is_edit;
  const canDelete = isAdmin || tasksAccess?.is_delete;
  const canExport = isAdmin || tasksAccess?.is_export;

  const filterOptions = [
    {
      id: "status",
      label: "Status",
      type: "multi-select",
      options: TaskStatus,
    },
    {
      id: "priority",
      label: "Priority",
      type: "multi-select",
      options: Priorities,
    },
    ...(type === "Project"
      ? []
      : [
          {
            id: "project",
            label: "Project",
            type: "multi-select",
            options: Projects,
          },
        ]),

    {
      id: "teams",
      label: "Team",
      type: "multi-select",
      options: Teams || [],
    },
    {
      id: "client",
      label: "Clients",
      type: "multi-select",
      options: Client || [],
    },
    ...(!mytask
      ? [
          {
            id: "assignee",
            label: "Assignee",
            type: "multi-select",
            options: employees,
          },
        ]
      : []),
    {
      id: "delayed",
      label: "Due",
      type: "single-select",
      options: [
        { label: "Due Today", value: "duetoday" },
        { label: "Due Tomorrow", value: "duetomorrow" },
        { label: "Overdue", value: "duepast" },
        { label: "Delayed", value: "delayed" },
      ],
    },
    {
      id: "recurring",
      label: "Recurring",
      type: "single-select",
      options: [
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],
    },
    {
      id: "business_segment",
      label: "Business Segment",
      type: "multi-select",
      options: BusinessSegment,
      customStyles: { minWidth: "165px" },
    },
  ];

  const priorityOptions = ["Low", "Medium", "High", "Critical"];
  const statusOptions = ["To Do", "In Progress", "Completed"];

  const newListsAssignTo = async (option) => {
    try {
      const res = await getData({
        endpoint: "Employee/GetAllEmployeesValueLabel",
        params: {
          project_id: option,
          status: JSON.stringify(["Active"]),
          // employee_id: cookies.euid,
        },
        token: cookies.e_t,
      });

      if (res) {
        let employeeList = res?.data?.employeeResponseValueLabel || [];
        const currentUserExists = employeeList.some(
          (employee) => employee.value === cookies.euid
        );

        if (!currentUserExists && cookies.euid) {
          employeeList = [
            ...employeeList,
            {
              value: cookies.euid,
              label: decodeCookieValue(cookies.e_n),
            },
          ];
        }

        setFilteredAssignedTo(employeeList);
      }
    } catch (err) {
      toast.error("Error Creating Task", { style: errorStyles });
    }
  };

  useEffect(() => {
    const fetchTaskDetails = async () => {
      try {
        if (searchParams.has("task_id")) {
          const task_id = searchParams.get("task_id"); // No JSON.parse here

          const res = await getData({
            endpoint: "Task/getTaskDetailsById",
            params: { task_id },
          });
          if (res) {
            setModalState((prevState) => ({
              ...prevState,
              modalId: task_id,
              modalData: res?.data?.[0],
              isModalOpen: true,
              title: "Edit Task",
            }));
          }
        }
      } catch (error) {
        console.error("Error fetching task details:", error);
      }
    };

    fetchTaskDetails();
  }, [searchParams]);

  useEffect(() => {
    (async () => {
      const resEmployee = await getEmployeeList({
        params: { ...(!isAdmin && { employee_id: cookies.euid }) },
        token: cookies.e_t,
      });

      const resRoles = await getRolesList({
        token: cookies.e_t,
      });

      const resDepartments = await getdepartmentList({
        token: cookies.e_t,
      });

      const BusinessSegmentRoles = await getBusinessSegmentList({
        token: cookies.e_t,
      });

      const teams = await getTeamsList({
        ...(!isAdmin && { params: { employee_id: cookies.euid } }),
        token: cookies.e_t,
      });

      const projects = await getAllProjects({
        ...(!isAdmin && { params: { employee_id: cookies.euid } }),
        token: cookies.e_t,
      });

      const clients = await getClientList({
        token: cookies.e_t,
      });

      setBusinessSegment(BusinessSegmentRoles?.data);
      setClient(clients?.data);
      setRoles(resRoles);
      setProjects(projects?.data);
      setTeams(teams?.data?.teams);
      setDepartment(resDepartments);
      setEmployees(resEmployee?.employeeResponseValueLabel);
    })();
  }, []);

  const projectfilter = type === "Project" ? [id] : filters?.project || [];

  const getUserData = useCallback(async () => {
    try {
      setIsLoading(true);

      const delayedFilters = filters?.delayed || [];
      const recurringFilters = filters?.recurring || [];
      const dueToday = delayedFilters.includes("duetoday") ? true : null;
      const dueTomorrow = delayedFilters.includes("duetomorrow") ? true : null;
      const showOverdueTasks = delayedFilters.includes("duepast") ? true : null;
      const delayed = delayedFilters.includes("delayed") ? true : null;

      let recurringtaskFilter = null;
      if (recurringFilters.length === 1) {
        recurringtaskFilter = recurringFilters.includes("yes");
      }

      const res = await getData({
        endpoint: "Task/getAllTasks",
        params: {
          // employee_id: null,
          search_query: searchedValue,
          page: home ? 1 : currentPage,
          page_limit: home ? 20 : itemsPerPage,
          status: home
            ? JSON.stringify(["New Task", "In Progress"])
            : JSON.stringify(filters?.status),
          priority: JSON.stringify(filters?.priority),
          type: JSON.stringify(filters?.type),
          assigned_employees: JSON.stringify(filters?.assignee),
          assigned_teams: JSON.stringify(filters?.teams),
          cclients: clientdash?.[0]
            ? JSON.stringify([clientdash?.[0]])
            : JSON.stringify(filters?.client),
          projects: JSON.stringify(projectfilter),
          employee_id:
            mytask || home ? cookies.euid : isAdmin ? null : cookies.euid,
          due_today: dueToday,
          show_delayed_tasks: delayed,
          show_due_tomorrow: dueTomorrow,
          show_overdue_tasks: showOverdueTasks,
          show_recurring_tasks: recurringtaskFilter,
          businessSegments: JSON.stringify(filters?.business_segment),
          roles:
            home || mytask
              ? JSON.stringify(["isTeamMember", "isDirectlyAssigned"])
              : null,
          // business_id: cookies.bid,
        },

        token: cookies.e_t,
      });
      if (res) {
        setTableData(res?.data);
        const total_subtasks = res?.data?.subtasks_info?.total_subtasks;
        const completed_subtasks = res?.data?.subtasks_info?.completed_subtasks;
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [
    cookies.e_t,
    currentPage,
    itemsPerPage,
    searchedValue,
    filters,
    clientdash?.[0],
  ]);

  useEffect(() => {
    getUserData();
  }, [getUserData]);

  //handling menu
  const menu = [
    canEdit && {
      icon: <Edit height="20" width="20" />,
      label: "Edit",
      onClick: () => {
        setAnchorEl(null);
        handleEdit(selectedRow);
      },
    },
    (canDelete || selectedRow?.is_team_lead || selectedRow?.is_owner) && {
      icon: <Delete />,
      label: "Delete",
      onClick: () => {
        setAnchorEl(null);
        handleDeleteModal(selectedRow);
      },
    },
  ].filter(Boolean);

  const handleDeleteModal = (data) => {
    setModalState((prevState) => ({
      ...prevState,
      isDeleteModalOpen: true,
      modalId: data.id,
      name: data.name,
    }));
  };

  const handleDeletion = async () => {
    try {
      await deleteData({
        endpoint: "Task/deleteTask",
        params: {
          task_id: modalState?.modalId,
        },
        token: cookies.e_t,
      });
      toast.success("Task Deleted Sucessfully", {
        style: confimationStyles,
        duration: 1000,
      });
      getUserData();
      setModalState((prevState) => ({
        ...prevState,
        isDeleteModalOpen: false,
      }));
    } catch (error) {
      toast.error("An Error Occured", {
        style: errorStyles,
        duration: 1000,
      });
    }
  };

  const handleStatusMenu = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const handleItemsPerPageChange = useCallback((perPage) => {
    setCurrentPage(1);
    setItemsPerPage(perPage);
  }, []);

  const handleEdit = (tableData) => {
    setModalState((prevState) => ({
      ...prevState,
      modalId: tableData.id,
      modalData: tableData,
      isModalOpen: true,
      title: "Edit Task",
    }));
  };

  const getClientLists = async () => {
    const clients = await getClientList({
      token: cookies.e_t,
    });

    setClient(clients?.data);
  };

  const handleAssignFetch = (projectId) => {
    if (!projectId) return;

    // If same project → do NOT call API again
    if (lastFetchedProjectId.current === projectId) return;

    // If different project → replace & fetch
    lastFetchedProjectId.current = projectId;
    newListsAssignTo(projectId);
  };

  const handleDownload = async () => {
    try {
      const delayedFilters = filters?.delayed || [];
      const recurringFilters = filters?.recurring || [];
      const dueToday = delayedFilters.includes("duetoday") ? true : null;
      const dueTomorrow = delayedFilters.includes("duetomorrow") ? true : null;
      const showOverdueTasks = delayedFilters.includes("duepast") ? true : null;
      const delayed = delayedFilters.includes("delayed") ? true : null;

      let recurringtaskFilter = null;
      if (recurringFilters.length === 1) {
        recurringtaskFilter = recurringFilters.includes("yes");
      }

      setIsExporting(true);
      const res = await getData({
        endpoint: "Task/exportTasks",
        token: cookies.e_t,
        params: {
          // employee_id : isAdmin ? null : cookies.euid,
          // projects: projectfilter?.length
          //   ? JSON.stringify(projectfilter)
          //   : null,
          // status: filters?.status?.length
          //   ? JSON.stringify(filters.status)
          //   : null,
          // priority: filters?.priority?.length
          //   ? JSON.stringify(filters.priority)
          //   : null,
          // type: filters?.type?.length ? JSON.stringify(filters.type) : null,
          // assigned_teams: JSON.stringify(filters?.teams),
          // assigned_employees: mytask ? JSON.stringify([cookies.euid]) : JSON.stringify(filters?.assignee),
          //   due_today: dueToday,
          //   show_delayed_tasks: delayed,
          //   show_due_tomorrow: dueTomorrow,
          //   show_overdue_tasks: showOverdueTasks,
          //   show_recurring_tasks: recurringtaskFilter,
          // clients : JSON.stringify(filters.client),
          // businessSegments: JSON.stringify(filters.business_segment),

          search_query: searchedValue,
          status: home
            ? JSON.stringify(["New Task", "In Progress"])
            : JSON.stringify(filters?.status),
          priority: JSON.stringify(filters?.priority),
          type: JSON.stringify(filters?.type),
          assigned_employees: JSON.stringify(filters?.assignee),
          assigned_teams: JSON.stringify(filters?.teams),
          clients: clientdash
            ? JSON.stringify(clientdash)
            : JSON.stringify(filters?.client),
          projects: JSON.stringify(projectfilter),
          employee_id:
            mytask || home ? cookies.euid : isAdmin ? null : cookies.euid,
          // show_delayed_tasks : showDelayedTasks,
          // due_date_filter : dueDateFilter,
          show_recurring_tasks: recurringtaskFilter,
          due_today: dueToday,
          show_delayed_tasks: delayed,
          show_due_tomorrow: dueTomorrow,
          show_overdue_tasks: showOverdueTasks,
          businessSegments: JSON.stringify(filters?.business_segment),
          roles:
            home || mytask
              ? JSON.stringify(["isTeamMember", "isDirectlyAssigned"])
              : null,
        },

        // fileName: "BusinessReport",
      });

      if (res) {
        // Call the handleClickDownload function with the URL and desired file name
        await handleClickDownload(
          res,
          type === "Project"
            ? `Project ${information?.name} Task Report`
            : "TaskReport"
        );

        toast.success("Task Exported Successfully", {
          style: confimationStyles,
          duration: 1000,
        });
      } else {
        toast("An Error Occured Please Try Again Later.", {
          duration: 1000,
          style: errorStyles,
        });
      }
    } catch (error) {
      toast.error("An Error Occured.", { style: errorStyles, duration: 1000 });
    } finally {
      setIsExporting(false);
    }
  };

  const updateTaskField = async (taskId, field, value, token) => {
    try {
      const response = await patchData({
        endpoint: `Task/updateTaskEntity`,
        params: { task_id: taskId },
        data: { [field]: value },
        token: token,
      });
      getUserData();
      return response;
    } catch (error) {
      throw error;
    }
  };

  const updateAssigned = async (taskId, type, selected, removed) => {
    let relation_to_add = selected
      ? selected?.map((emp) => emp.employee_id)
      : [];
    let relation_to_delete = removed
      ? removed?.map((emp) => emp.employee_id)
      : [];

    try {
      const response = await postData({
        endpoint: `Task/UpdateAssignedTask`,
        params: {},
        data: {
          task_id: taskId,
          assigned_type: type,
          created_by: cookies.euid,
          relation_to_add: relation_to_add,
          relation_to_delete: relation_to_delete,
        },
        token: cookies.e_t,
      });
      getUserData();
      return response;
    } catch (error) {
      throw error;
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Task Title",
      minWidth: 280,
      sortable: true,
      cellClassName: "cursor-pointer",
      renderCell: (params) => {
        const totalSubtasks = params?.row?.subtasks_info?.total_subtasks || 0;
        const completedSubtasks =
          params?.row?.subtasks_info?.completed_subtasks || 0;
        const displayText = params.value;

        return (
          <div className="d-flex align-items-center justify-content-between w-100">
            <div>
              <Tooltip
                title={`${params.value} - ${completedSubtasks}/${totalSubtasks}`}
                arrow
              >
                <span className="multiline-ellipsis">{displayText}</span>
              </Tooltip>
            </div>
            <div>
              {totalSubtasks > 0 && (
                <div className="flex items-center ml-2 text-gray-500">
                  <CheckCheck size={16} className="mr-1" />
                  <span style={{ fontSize: "0.85rem" }}>
                    {completedSubtasks}/{totalSubtasks}
                  </span>
                </div>
              )}
            </div>
          </div>
        );
      },
    },
    {
      field: "elapsed_time",
      headerName: "Logged Time",
      minWidth: 150,
      sortable: true,
      renderCell: (params) => {
        return <span>{formatTime(params?.row?.elapsed_time)}</span>;
      },
    },
    {
      field: "client_name",
      headerName: "Client",
      minWidth: 150,
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span className="multiline-ellipsis">{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "project_name",
      headerName: "Project",
      minWidth: 150,
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span className="multiline-ellipsis">{params.value}</span>
        </Tooltip>
      ),
    },
    // {
    //   field: "type",
    //   headerName: "Type",
    //   minWidth: 120,
    //   sortable: true,
    // },
    {
      field: "assigned_employees",
      headerName: "Assigned To",
      cellClassName: "cursor-pointer",
      minWidth: 200,
      sortable: true,
      editable: true,

      renderCell: (params) => {
        const employees = params.row.assigned_employees || [];

        // Get all employee names
        const employeeNames = employees
          .map((emp) => emp.employee_name)
          .filter((name) => name?.trim());

        // Show first two and the count of remaining
        const displayText =
          employeeNames.length > 2
            ? `${employeeNames.slice(0, 2).join(", ")} +${
                employeeNames.length - 2
              }`
            : employeeNames.join(", ");

        return (
          <Tooltip title={employeeNames.join(", ")} arrow>
            <span
              style={{
                cursor: "pointer",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {displayText}
            </span>
          </Tooltip>
        );
      },
      renderEditCell: (params) => {
        const formattedOptions = filteredAssignedTo.map((emp) => ({
          employee_id: emp.value,
          employee_name: emp.label,
        }));

        // Get current selection or initialize as empty array
        let selectedEmployees = params.value || [];
        let removedEmployees = [];

        const handleChange = (event) => {
          const newSelection = event.target.value; // Get the selected values

          // Find duplicates in the new selection
          const employeeCounts = {};
          newSelection.forEach((emp) => {
            employeeCounts[emp.employee_id] =
              (employeeCounts[emp.employee_id] || 0) + 1;
          });

          // Filter out employees that appear multiple times
          const duplicateEmployeeIds = Object.keys(employeeCounts).filter(
            (id) => employeeCounts[id] > 1
          );

          // Create a clean selection with duplicates removed
          const cleanSelection = newSelection.filter(
            (emp) => !duplicateEmployeeIds.includes(emp.employee_id.toString())
          );

          // Add the duplicates to removedEmployees
          const duplicatesRemoved = selectedEmployees.filter((emp) =>
            duplicateEmployeeIds.includes(emp.employee_id.toString())
          );
          removedEmployees = [...removedEmployees, ...duplicatesRemoved];

          // Also track any employee that was in the original selection but not in the new clean selection
          const regularRemovals = selectedEmployees.filter(
            (emp) =>
              !cleanSelection.some(
                (newEmp) => newEmp.employee_id === emp.employee_id
              ) && !duplicateEmployeeIds.includes(emp.employee_id.toString())
          );

          removedEmployees = [...removedEmployees, ...regularRemovals];

          // Update the selected employees state
          selectedEmployees = cleanSelection;

          setRemoved((prev) => [...prev, ...removedEmployees]);

          // Update the cell value
          params.api.setEditCellValue({
            id: params.id,
            field: params.field,
            value: selectedEmployees,
          });
        };

        const handleClose = async () => {
          const row = params.api.getRow(params.id);

          await updateAssigned(row.id, "Employee", selectedEmployees, removed);

          setRemoved([]);
        };
        return (
          <Select
            multiple
            value={selectedEmployees}
            onChange={handleChange}
            onClose={handleClose} // Call API only when the dropdown closes
            className="editable-select"
            fullWidth
            renderValue={(selected) =>
              selected.map((s) => s.employee_name).join(", ")
            }
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 300, // Set the max height of the dropdown list
                  overflow: "auto",
                  cursor: "pointer", // Enable scrolling if the content exceeds the height
                },
              },
            }}
          >
            {formattedOptions.map((option) => (
              <MenuItem
                key={option.employee_id}
                value={option}
                sx={{
                  backgroundColor: selectedEmployees.some(
                    (emp) => emp.employee_id === option.employee_id
                  )
                    ? "#F5F6FA" // Light gray background when selected
                    : "transparent",
                }}
                className="editable-select-option"
              >
                {option.employee_name}
              </MenuItem>
            ))}
          </Select>
        );
      },
    },
    {
      field: "assigned_teams",
      headerName: "Assigned Teams",
      minWidth: 200,
      sortable: true,

      renderCell: (params) => {
        const teams = params.row.assigned_teams || [];

        // Get all employee names
        const teamNames = teams
          .map((team) => team.team_name)
          .filter((name) => name?.trim());

        // Show first two and the count of remaining
        const displayText =
          teamNames.length > 2
            ? `${teamNames.slice(0, 2).join(", ")} +${teamNames.length - 2}`
            : teamNames.join(", ");

        return (
          <Tooltip title={teamNames.join(", ")} arrow>
            <span
              style={{
                cursor: "pointer",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {displayText}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "priority",
      headerName: "Priority",
      minWidth: 150,
      sortable: true,
      cellClassName: "cursor-pointer",
      renderCell: (params) => {
        return <ColorDots priority={params.value} />;
      },

      editable: true, // Enable editing
      renderEditCell: (params) => (
        <Select
          value={params.value}
          onChange={async (e) => {
            const newValue = e.target.value;
            const originalValue = params.value;

            // Optimistic update
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: newValue,
            });

            const row = params.api.getRow(params.id);
            await updateTaskField(row.id, "priority", newValue, cookies.e_t);
          }}
          fullWidth
          className="editable-select"
        >
          {priorityOptions.map((option) => (
            <MenuItem
              key={option}
              value={option}
              className="editable-select-option"
            >
              {option}
            </MenuItem>
          ))}
        </Select>
      ),
    },
    {
      field: "due_date",
      headerName: "Due Date",
      minWidth: 150,
      renderCell: (params) => {
        const dueDate = params?.row?.due_date;
        const isOverdue =
          dueDate &&
          moment(dueDate).isBefore(moment(), "day") &&
          params?.row?.status !== "Completed";
        return (
          <span
            style={{
              color: isOverdue ? "#d93025" : "inherit",
              fontWeight: isOverdue ? "600" : "normal",
            }}
          >
            {dueDate ? moment(dueDate).format("DD/MM/YYYY") : ""}
          </span>
        );
      },
      sortable: true,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 200,
      sortable: true,
      renderCell: (params) => {
        const { status, completed_at, due_date } = {
          status: params.value,
          completed_at: params.row.completed_at,
          due_date: params.row.due_date,
        };

        const getDateOnly = (date) =>
          date ? new Date(date).toISOString().split("T")[0] : null;

        const isDelayed =
          completed_at &&
          due_date &&
          getDateOnly(completed_at) > getDateOnly(due_date);

        return (
          <div className="d-flex items-center gap-2">
            <StatusBackground status={status} />
            {isDelayed && <StatusBackground status={"Delayed"} />}
          </div>
        );
      },
      cellClassName: "cursor-pointer",
      editable: true,
      renderEditCell: (params) => {
        // Check isPresent for this specific row
        // const isEmployee = params?.row?.assigned_employees.map((emp)=> emp.employee_id);
        // const isPresent = isEmployee && cookies?.euid ? isEmployee.includes(cookies.euid) : false;

        const isAllowed = params?.row?.allowed_to_log_time;

        return (
          <Select
            value={params.value}
            className="editable-select"
            onChange={async (e) => {
              const newStatus = e.target.value;
              const originalStatus = params.value;

              // Check if user is not assigned to this task
              if (!isAllowed) {
                // Show the confirmation modal and don't change status
                setIsConfirmModal(true);
                // Reset the select to original value
                params.api.setEditCellValue({
                  id: params.id,
                  field: params.field,
                  value: originalStatus,
                });
                return; // Exit early, don't proceed with status change
              }

              const totalSubtasks =
                params?.row?.subtasks_info?.total_subtasks || 0;
              const completedSubtasks =
                params?.row?.subtasks_info?.completed_subtasks || 0;

              setGridParams(params);

              if (newStatus !== "Completed") {
                // For non-Completed status, update immediately
                params.api.setEditCellValue({
                  id: params.id,
                  field: params.field,
                  value: newStatus,
                });

                try {
                  const row = params.api.getRow(params.id);
                  setSelectedRow(row);
                  await updateTaskField(
                    row.id,
                    "status",
                    newStatus,
                    cookies.e_t
                  );
                  toast.success("Status updated successfully", {
                    style: confimationStyles,
                    duration: 1000,
                  });
                } catch (error) {
                  params.api.setEditCellValue({
                    id: params.id,
                    field: params.field,
                    value: originalStatus,
                  });
                  toast.error("Failed to update status", {
                    style: errorStyles,
                    duration: 1000,
                  });
                  console.error("Error updating status:", error);
                }
              } else {
                // For Completed status
                const row = params.api.getRow(params.id);
                setSelectedRow(row);

                if (totalSubtasks !== completedSubtasks) {
                  setIsConfirmCompleteModalOpen(true);
                  setIsUpdate(false); // Prevent immediate update
                } else {
                  // Skip confirmation and open log timer directly
                  setIsUpdate(true);
                  setLogTimer(true);
                  params.api.setEditCellValue({
                    id: params.id,
                    field: params.field,
                    value: newStatus,
                  });
                  try {
                    await updateTaskField(
                      row.id,
                      "status",
                      newStatus,
                      cookies.e_t
                    );
                    toast.success("Status updated successfully", {
                      style: confimationStyles,
                      duration: 1000,
                    });
                  } catch (error) {
                    params.api.setEditCellValue({
                      id: params.id,
                      field: params.field,
                      value: originalStatus,
                    });
                    toast.error("Failed to update status", {
                      style: errorStyles,
                      duration: 1000,
                    });
                    console.error("Error updating status:", error);
                  }
                }
              }
            }}
            fullWidth
          >
            {TaskStatusOptions.map((option) => (
              <MenuItem
                key={option}
                value={option}
                className="editable-select-option"
              >
                {option}
              </MenuItem>
            ))}
          </Select>
        );
      },
    },
    {
      field: "is_recurring",
      headerName: "Recurring",
      minWidth: 120,
      renderCell: (params) => {
        return <div>{params?.row?.is_recurring ? "Yes" : "No"}</div>;
      },
      sortable: true,
    },
    {
      field: "created_by_name",
      headerName: "Created By",
      minWidth: 150,
      renderCell: (params) => {
        return <span style={{}}>{params?.row?.created_by_name}</span>;
      },
      sortable: true,
    },
    {
      field: "created_at",
      headerName: "Created Date",
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div>
            {params?.row?.created_at &&
              moment(params.row?.created_at).format("DD/MM/YYYY hh:mm a")}
          </div>
        );
      },
      sortable: true,
    },
    {
      field: "modified_at",
      headerName: "Updated Date",
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div>
            {params?.row?.modified_at &&
              moment(params.row?.modified_at).format("DD/MM/YYYY hh:mm a")}
          </div>
        );
      },
      sortable: true,
    },
    {
      field: "completed_at",
      headerName: "Completion Date",
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div>
            {params?.row?.completed_at &&
              moment(params.row?.completed_at).format("DD/MM/YYYY hh:mm a")}
          </div>
        );
      },
      sortable: true,
    },

    // ...(canEdit || canDelete || selectedRow?.is_owner || selectedRow?.is_team_lead
    //   ? [
    {
      field: "actions",
      headerName: "",
      minWidth: 20,
      renderCell: (params) => {
        return (
          <div className="table-icons-container">
            {(canEdit ||
              canDelete ||
              selectedRow?.is_owner ||
              selectedRow?.is_team_lead) && (
              <div onClick={(event) => handleStatusMenu(event, params.row)}>
                <VerticalMenu />
              </div>
            )}

            <CustomMenu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              items={menu}
            />
          </div>
        );
      },
    },
    // ]
    // : []),
  ];

  const openModal = (title, data) => {
    const modalId = uuidv4();
    setModalState((prevState) => ({
      ...prevState,
      modalId,
      isModalOpen: true,
      title,
      modalData: data,
    }));
  };

  const getFilteredColumns = () => {
    if (home) {
      // Return only specific columns for home view (up to assigned_teams)
      return columns.filter((col) =>
        [
          "name",
          "elapsed_time",
          "client_name",
          "project_name",
          "assigned_employees",
          "assigned_teams",
          "actions",
        ].includes(col.field)
      );
    }
    return columns;
  };

  const closeModal = () => {
    // if(type === 'submitted'){
    setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
    // } else {
    //   // setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
    //   setIsFormDirty(true)
    //   setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
    // }
  };

  const handleFilterChange = (newFilters) => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
    setFilters(newFilters);
  };

  const CustomNoRowsOverlay = React.memo(() => {
    return (
      <>
        <NoContentCard
          title="No Tasks Found"
          type="Task"
          // subtitle={
          //   "Looks like you’re all caught up—check back later for new assignments."
          // }
        />
      </>
    );
  });

  return (
    <div
      id="Employee-Management"
      className={
        !home && !clientshow ? "main-container" : "main-container-home"
      }
    >
      {!home && !clientshow ? (
        <div className="d-flex justify-content-between">
          <div className="d-flex gap-2 segregation-container">
            <Search
              placeholder="Search"
              onSearchEmit={(item) => {
                if (currentPage !== 1) {
                  setCurrentPage(1);
                }
                setSearchedValue(item);
              }}
            />
          </div>

          <div className="d-flex gap-2">
            {canExport && (
              <CustomButton
                text={isExporting ? "Exporting..." : "Export"}
                handleClick={() => handleDownload()}
                icon={
                  isExporting ? (
                    <Loader className="animate-spin" size={18} />
                  ) : (
                    <Upload size={16} />
                  )
                }
                disabled={isExporting || disabled}
                iconRequired
              />
            )}

            {canCreate && (
              <CustomButton
                text="Create Task"
                type="btn-primary"
                handleClick={() => openModal("Create Task")}
              />
            )}
          </div>
        </div>
      ) : null}

      {!home && !clientshow ? (
        <div className="mt-2">
          <CommonFilter
            filters={filterOptions}
            onFilterChange={handleFilterChange}
            initialFilters={filters}
          />
        </div>
      ) : null}

      <div className="mt-3">
        <TaskCustomDatagrid
          columns={getFilteredColumns()}
          CustomNoRowsOverlay={CustomNoRowsOverlay}
          rows={tableData?.tasks || []}
          getRowId={(row) => row.id}
          isLoadingStateProvided={true}
          isLoading={isLoading}
          onCellClick={(params, event) => {
            if (params.field === "name" && canEdit) {
              setAnchorEl(null);
              handleEdit(params?.row);
            }
            if (params.field === "assigned_employees") {
              handleAssignFetch(params.row.project_id);
            }
          }}
        />
      </div>

      {!home && tableData?.total_records > 10 && (
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={tableData?.total_records}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      {modalState?.isModalOpen && (
        <SideOverlay
          id={modalState?.modalId}
          title={modalState.title}
          onClose={closeModal}
          isOpen={modalState?.isModalOpen}
          side="right"
          width="650px"
        >
          {modalState.title === "Edit Task" ? (
            <TaskViewModal
              mytask={mytask}
              isAdmin={isAdmin}
              tableData={tableData}
              onFormDirty={setIsFormDirty}
              modalState={modalState}
              refetchData={getUserData}
              Projects={Projects}
              clientList={Client}
              onClose={() => closeModal("submit")}
              // employeeList={employees}
              departmentList={department}
              rolesList={roles}
              teamList={Teams}
              refetchClientList={getClientLists}
              // setLogModalOpen={setLogModal}
            />
          ) : (
            <Form
              onFormDirty={setIsFormDirty}
              isAdmin={isAdmin}
              initialData={
                modalState.title === "Edit Task" ? modalState.modalData : null
              }
              information={information}
              refetchData={getUserData}
              Projects={Projects}
              clientList={Client}
              onClose={() => closeModal("submit")}
              // employeeList={employees}
              departmentList={department}
              rolesList={roles}
              teamList={Teams}
              refetchClientList={getClientLists}
              type={type}
              // setLogModalOpen={setLogModal}
            />
          )}
        </SideOverlay>
      )}

      {/* {logModal && <LogTimeModal open={logModal} setOpen={setLogModal}/>} */}

      {modalState.isDeleteModalOpen && (
        <DeleteModal
          name={modalState.name}
          id={modalState.modalId}
          isActive={modalState.isDeleteModalOpen}
          onClose={() =>
            setModalState((prevState) => ({
              ...prevState,
              isDeleteModalOpen: false,
            }))
          }
          title="Task"
          onClick={handleDeletion}
        />
      )}

      {isConfirmCompleteModalOpen && (
        <DeleteModal
          name="task"
          type="Confirm"
          id="confirm-complete"
          isActive={isConfirmCompleteModalOpen}
          onClose={() => {
            setIsConfirmCompleteModalOpen(false);
            setIsUpdate(false);
          }}
          title="Task Completion"
          description="Do you want to complete this task even though it has unfinished subtasks? All subtasks will be marked as completed."
          onClick={async () => {
            setIsUpdate(true);
            setLogTimer(true);
            setIsConfirmCompleteModalOpen(false);

            // Update task status to Completed
            try {
              const row = selectedRow;
              await updateTaskField(row.id, "status", "Completed", cookies.e_t);
              toast.success("Status updated successfully", {
                style: confimationStyles,
                duration: 1000,
              });
              // Update the UI
              gridParams.api.setEditCellValue({
                id: row.id,
                field: "status",
                value: "Completed",
              });
            } catch (error) {
              toast.error("Failed to update status", {
                style: errorStyles,
                duration: 1000,
              });
              console.error("Error updating status:", error);
            }
          }}
        />
      )}

      {confirmModal && (
        <ConfirmModal
          title="Assigned Member"
          type="Not"
          isActive={confirmModal}
          onClose={() => setIsConfirmModal(false)}
          description="Please got first assigned to this task then you can log the time"
          onClick={() => setIsConfirmModal(false)}
        />
      )}

      {/* show log timer on task completion */}

      {logTimer && (
        <LogTime
          task_id={selectedRow?.id}
          open={logTimer}
          setOpen={setLogTimer}
          logData={logData}
          setLogData={setLogData}
          name={selectedRow?.name}
          dirtyFlag={setDirtyFlag}
          refetchData={getUserData}
        />
      )}
    </div>
  );
};

export default TaskManagement;
